<template>
  <div class="dashboard-container error-container d-flex justify-content-center">
    <div class="dashboard-content d-flex flex-column">
      <div class="card mb-3">
        <div class="card-header text-white">
          <h5 class="mb-0"><strong>{{ $t('global.error_heading') }}</strong></h5>
        </div>
        <div class="card-body bg-light">
          <h5 class="card-title mb-4">{{ $t('global.error_code') }} {{ errorCode }}</h5>
          <p class="card-text mb-4">{{ $t('global.error_status') }}: {{ errorMessage }}</p>
          <div class="mt-4 pt-4">
            <button type="button" class="btn btn-medium btn-orange-dark" @click="$router.go(-2)">
              <arrow-left-icon></arrow-left-icon>
              <span>{{ $t('global.back') }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ArrowLeftIcon } from 'vue-feather-icons'

export default {
  name: 'Error',

  props: ['errorCode', 'errorMessage'],

  components: { ArrowLeftIcon }
}
</script>
